<template>
    <div class="lottery-container">
        <div class="sub-container">
            <img src="/assets/bonus_image.png" class="img-lottery" style="width: 100%;height: 100%;" />
        </div>

        <div style="box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;" class="p-2">
            <div class="card-body">
                <p class="text-uppercase text-primary fw-semibold small mb-1 text-start">
                    Scratch-Off • #1556
                </p>

                <h5 class="card-title fw-bold text-dark mb-3 text-start">BONUS RED</h5>

                <div class="d-flex align-items-center">
                    <div class="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center me-2"
                        style="width: 30px; height: 30px;background: #1F357C!important;">
                        <i class="fa-solid fa-sack-dollar"></i>
                    </div>
                    <div>
                        <p class=" m-0 p-0" style="font-size: 8px;text-align: left;">UltimatePrize</p>
                        <p class="fw-semibold fs-5 text-dark m-0 p-0">€.100.000.000</p>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {

};
</script>

<style scoped>
.lottery-container {
    margin-right: 20px;
    font-family: sans-serif;
    background: #fff;
    border-radius: 16px;
    max-width: 100%;
    margin: auto;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.sub-container {
    border-bottom: 4px solid #FFCD05;
}

.countdown-line {
    border-top: 10px solid #FFCD05;
    border-radius: 5px;
}

.lottery-header h1 {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
    padding: 0;
    color: #707070;
}

.lottery-header h2 {
    color: #2e3d96;
    margin: 0;
    font-weight: bold;
    margin-bottom: 8px;
    padding: 0;
    font-size: 18px;
}

.lottery-header p {
    font-size: 14px;
}

.place {
    margin: 10px 0;
}

.place-label {
    font-style: italic;
    margin-bottom: 5px;
}

.results-link {
    color: white;
    text-decoration: underline;
    font-weight: bold;
}
</style>